import { Row } from "reactstrap";
import React from "react";
import { TextStyle } from "@shopify/polaris";

const Tutorials = () => {
  const listVideo = [
    {
      title: "TUTORIAL: Connect your PayPal account to the SyncTrack app",
      url: "939S7HqgJi4",
    },
    {
      title:
        "[SyncTrack ‑ Add tracking auto] - Instructions for integrating multiple stores",
      url: "pokFbQ3YvHc",
    },
  ];
  return (
    <div className="faq-button">
      {listVideo.map((item, index) => {
        return (
          <div>
            <Row className="pt-2 pb-3 pr-4 pl-4">
              <div className="mb-3">
                <TextStyle variation="strong">{item.title}</TextStyle>
              </div>
              <iframe
                src={"https://www.youtube.com/embed/" + item.url}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="Video Tutorial"
                width="100%"
                height="220"
              />
            </Row>
            <hr />
          </div>
        );
      })}
    </div>
  );
};

export default Tutorials;
